import styled from "styled-components";

export const StyledInputTags = styled.div`
    ${({ customStyle }) => customStyle && customStyle};
`;
